import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { MSplitLayoutService } from './split-layout.service';
import { IMSplitDirection } from './typings';

@Component({
  selector: 'm-split-layout-control',
  template: `
    <span class="m-split-layout-control" nz-popover [nzPopoverContent]="contentTpl" nzPopoverPlacement="bottomRight">
      <i nz-icon>
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="04-03平铺模式/视图配置" transform="translate(-1200.000000, -12.000000)">
              <g id="-mockplus-" transform="translate(56.000000, 0.000000)">
                <g id="6.Public全局/图标/Line/left" transform="translate(1144.000000, 12.000000)">
                  <path
                    d="M7,10 L7,11 L2,11 L2,10 L7,10 Z M7,7.5 L7,8.5 L2,8.5 L2,7.5 L7,7.5 Z M7,5 L7,6 L2,6 L2,5 L7,5 Z"
                    id="形状结合"
                    fill="#107CEE"
                  ></path>
                  <path
                    d="M16,0 L16,16 L0,16 L0,0 L16,0 Z M8,1 L1,1 L1,15 L8,15 L8,1 Z M15,1 L9,1 L9,15 L15,15 L15,1 Z"
                    id="形状结合"
                    fill="#3D4757"
                    fill-rule="nonzero"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </i>
      {{ mText }}
    </span>
    <ng-template #contentTpl>
      <span class="m-split-layout-control-content-text">分屏视图</span>
      <br />
      <span class="m-split-layout-control-content-icon" (click)="onOnlyLeft()">
        <i nz-icon *ngIf="(splitLayoutService.leftArea$ | async) === 100">
          <svg
            width="34px"
            height="26px"
            viewBox="0 0 34 26"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="设计" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="04-03平铺模式/视图配置" transform="translate(-1262.000000, -308.000000)">
                <g id="分屏视图" transform="translate(1251.000000, 275.000000)">
                  <g id="编组-3" transform="translate(11.000000, 33.000000)">
                    <rect id="矩形" stroke="#107CEE" fill="#FFFFFF" x="0.5" y="0.5" width="33" height="25" rx="1"></rect>
                    <rect id="矩形" stroke="#107CEE" fill-opacity="0.2" fill="#107CEE" x="0.5" y="0.5" width="33" height="5" rx="1"></rect>
                    <path
                      d="M3.75,2.5 C4.16421356,2.5 4.5,2.83578644 4.5,3.25 C4.5,3.66421356 4.16421356,4 3.75,4 C3.33578644,4 3,3.66421356 3,3.25 C3,2.83578644 3.33578644,2.5 3.75,2.5 Z M6,2.5 C6.41421356,2.5 6.75,2.83578644 6.75,3.25 C6.75,3.66421356 6.41421356,4 6,4 C5.58578644,4 5.25,3.66421356 5.25,3.25 C5.25,2.83578644 5.58578644,2.5 6,2.5 Z M8.25,2.5 C8.66421356,2.5 9,2.83578644 9,3.25 C9,3.66421356 8.66421356,4 8.25,4 C7.83578644,4 7.5,3.66421356 7.5,3.25 C7.5,2.83578644 7.83578644,2.5 8.25,2.5 Z"
                      id="形状结合"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M14.056,20.568 L14.968,18.168 L18.904,18.168 L19.816,20.568 L20.884,20.568 L17.512,12 L16.372,12 L13,20.568 L14.056,20.568 Z M18.592,17.34 L15.28,17.34 L16.924,13.056 L16.972,13.056 L18.592,17.34 Z"
                      id="A"
                      fill="#107CEE"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </i>
        <i nz-icon *ngIf="(splitLayoutService.leftArea$ | async) !== 100">
          <svg
            width="34px"
            height="26px"
            viewBox="0 0 34 26"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="设计" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="04-03平铺模式/视图配置" transform="translate(-1262.000000, -103.000000)">
                <g id="分屏视图" transform="translate(1251.000000, 70.000000)">
                  <g id="编组-3" transform="translate(11.000000, 33.000000)">
                    <rect id="矩形" stroke="#979797" fill="#FFFFFF" x="0.5" y="0.5" width="33" height="25" rx="1"></rect>
                    <rect id="矩形" stroke="#979797" fill="#B8B8B8" x="0.5" y="0.5" width="33" height="5" rx="1"></rect>
                    <path
                      d="M3.75,2.5 C4.16421356,2.5 4.5,2.83578644 4.5,3.25 C4.5,3.66421356 4.16421356,4 3.75,4 C3.33578644,4 3,3.66421356 3,3.25 C3,2.83578644 3.33578644,2.5 3.75,2.5 Z M6,2.5 C6.41421356,2.5 6.75,2.83578644 6.75,3.25 C6.75,3.66421356 6.41421356,4 6,4 C5.58578644,4 5.25,3.66421356 5.25,3.25 C5.25,2.83578644 5.58578644,2.5 6,2.5 Z M8.25,2.5 C8.66421356,2.5 9,2.83578644 9,3.25 C9,3.66421356 8.66421356,4 8.25,4 C7.83578644,4 7.5,3.66421356 7.5,3.25 C7.5,2.83578644 7.83578644,2.5 8.25,2.5 Z"
                      id="形状结合"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M14.056,20.568 L14.968,18.168 L18.904,18.168 L19.816,20.568 L20.884,20.568 L17.512,12 L16.372,12 L13,20.568 L14.056,20.568 Z M18.592,17.34 L15.28,17.34 L16.924,13.056 L16.972,13.056 L18.592,17.34 Z"
                      id="A"
                      fill="#585858"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </i>
      </span>
      <span class="m-split-layout-control-content-icon" (click)="onVertical()">
        <i nz-icon *ngIf="verticalIcon === 'active'">
          <svg
            width="34px"
            height="26px"
            viewBox="0 0 34 26"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="设计" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="04-03平铺模式/视图配置" transform="translate(-1362.000000, -308.000000)">
                <g id="分屏视图" transform="translate(1251.000000, 275.000000)">
                  <g id="编组-4" transform="translate(111.000000, 33.000000)">
                    <g id="编组-3">
                      <rect id="矩形" stroke="#107CEE" fill="#FFFFFF" x="0.5" y="0.5" width="33" height="25" rx="1"></rect>
                      <rect
                        id="矩形"
                        stroke="#107CEE"
                        fill-opacity="0.2"
                        fill="#107CEE"
                        x="0.5"
                        y="0.5"
                        width="33"
                        height="5"
                        rx="1"
                      ></rect>
                      <path
                        d="M3.75,2.5 C4.16421356,2.5 4.5,2.83578644 4.5,3.25 C4.5,3.66421356 4.16421356,4 3.75,4 C3.33578644,4 3,3.66421356 3,3.25 C3,2.83578644 3.33578644,2.5 3.75,2.5 Z M6,2.5 C6.41421356,2.5 6.75,2.83578644 6.75,3.25 C6.75,3.66421356 6.41421356,4 6,4 C5.58578644,4 5.25,3.66421356 5.25,3.25 C5.25,2.83578644 5.58578644,2.5 6,2.5 Z M8.25,2.5 C8.66421356,2.5 9,2.83578644 9,3.25 C9,3.66421356 8.66421356,4 8.25,4 C7.83578644,4 7.5,3.66421356 7.5,3.25 C7.5,2.83578644 7.83578644,2.5 8.25,2.5 Z"
                        id="形状结合"
                        fill="#FFFFFF"
                      ></path>
                      <path
                        d="M14.88,14.14 L15.64,12.14 L18.92,12.14 L19.68,14.14 L20.57,14.14 L17.76,7 L16.81,7 L14,14.14 L14.88,14.14 Z M18.66,11.45 L15.9,11.45 L17.27,7.88 L17.31,7.88 L18.66,11.45 Z"
                        id="A"
                        fill="#107CEE"
                        fill-rule="nonzero"
                      ></path>
                      <path
                        d="M17.17,24.14 C17.9,24.14 18.48,23.99 18.9,23.71 C19.39,23.37 19.64,22.85 19.64,22.15 C19.64,21.67 19.5,21.29 19.24,20.99 C18.98,20.69 18.62,20.49 18.15,20.41 C18.51,20.29 18.8,20.1 19.02,19.84 C19.23,19.55 19.34,19.2 19.34,18.8 C19.34,18.24 19.15,17.8 18.77,17.48 C18.38,17.16 17.85,17 17.19,17 L14,17 L14,24.14 L17.17,24.14 Z M16.99,20.12 L14.82,20.12 L14.82,17.69 L17,17.69 C17.5,17.69 17.88,17.78 18.14,17.98 C18.4,18.18 18.53,18.48 18.53,18.88 C18.53,19.29 18.39,19.6 18.13,19.81 C17.87,20.01 17.49,20.12 16.99,20.12 Z M17.1,23.45 L14.82,23.45 L14.82,20.8 L17.1,20.8 C17.65,20.8 18.07,20.9 18.36,21.12 C18.66,21.34 18.82,21.68 18.82,22.14 C18.82,22.6 18.64,22.95 18.29,23.17 C17.99,23.35 17.6,23.45 17.1,23.45 Z"
                        id="B"
                        fill="#107CEE"
                        fill-rule="nonzero"
                      ></path>
                    </g>
                    <polygon
                      id="路径-4"
                      fill="#107CE0"
                      fill-rule="nonzero"
                      transform="translate(17.500000, 15.230000) rotate(90.000000) translate(-17.500000, -15.230000) "
                      points="18 -1.27 18 31.73 17 31.73 17 -1.27"
                    ></polygon>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </i>
        <i nz-icon *ngIf="verticalIcon === 'non-active'">
          <svg
            width="34px"
            height="26px"
            viewBox="0 0 34 26"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="设计" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="04-03平铺模式/视图配置" transform="translate(-1362.000000, -103.000000)">
                <g id="分屏视图" transform="translate(1251.000000, 70.000000)">
                  <g id="编组-4" transform="translate(111.000000, 33.000000)">
                    <g id="编组-3">
                      <rect id="矩形" stroke="#848484" fill="#FFFFFF" x="0.5" y="0.5" width="33" height="25" rx="1"></rect>
                      <rect
                        id="矩形"
                        stroke="#888889"
                        fill-opacity="0.6"
                        fill="#888889"
                        x="0.5"
                        y="0.5"
                        width="33"
                        height="5"
                        rx="1"
                      ></rect>
                      <path
                        d="M3.75,2.5 C4.16421356,2.5 4.5,2.83578644 4.5,3.25 C4.5,3.66421356 4.16421356,4 3.75,4 C3.33578644,4 3,3.66421356 3,3.25 C3,2.83578644 3.33578644,2.5 3.75,2.5 Z M6,2.5 C6.41421356,2.5 6.75,2.83578644 6.75,3.25 C6.75,3.66421356 6.41421356,4 6,4 C5.58578644,4 5.25,3.66421356 5.25,3.25 C5.25,2.83578644 5.58578644,2.5 6,2.5 Z M8.25,2.5 C8.66421356,2.5 9,2.83578644 9,3.25 C9,3.66421356 8.66421356,4 8.25,4 C7.83578644,4 7.5,3.66421356 7.5,3.25 C7.5,2.83578644 7.83578644,2.5 8.25,2.5 Z"
                        id="形状结合"
                        fill="#FFFFFF"
                      ></path>
                      <path
                        d="M14.88,14.14 L15.64,12.14 L18.92,12.14 L19.68,14.14 L20.57,14.14 L17.76,7 L16.81,7 L14,14.14 L14.88,14.14 Z M18.66,11.45 L15.9,11.45 L17.27,7.88 L17.31,7.88 L18.66,11.45 Z"
                        id="A"
                        fill="#585858"
                        fill-rule="nonzero"
                      ></path>
                      <path
                        d="M17.17,24.14 C17.9,24.14 18.48,23.99 18.9,23.71 C19.39,23.37 19.64,22.85 19.64,22.15 C19.64,21.67 19.5,21.29 19.24,20.99 C18.98,20.69 18.62,20.49 18.15,20.41 C18.51,20.29 18.8,20.1 19.02,19.84 C19.23,19.55 19.34,19.2 19.34,18.8 C19.34,18.24 19.15,17.8 18.77,17.48 C18.38,17.16 17.85,17 17.19,17 L14,17 L14,24.14 L17.17,24.14 Z M16.99,20.12 L14.82,20.12 L14.82,17.69 L17,17.69 C17.5,17.69 17.88,17.78 18.14,17.98 C18.4,18.18 18.53,18.48 18.53,18.88 C18.53,19.29 18.39,19.6 18.13,19.81 C17.87,20.01 17.49,20.12 16.99,20.12 Z M17.1,23.45 L14.82,23.45 L14.82,20.8 L17.1,20.8 C17.65,20.8 18.07,20.9 18.36,21.12 C18.66,21.34 18.82,21.68 18.82,22.14 C18.82,22.6 18.64,22.95 18.29,23.17 C17.99,23.35 17.6,23.45 17.1,23.45 Z"
                        id="B"
                        fill="#585858"
                        fill-rule="nonzero"
                      ></path>
                    </g>
                    <polygon
                      id="路径-4"
                      fill="#979797"
                      fill-rule="nonzero"
                      transform="translate(17.500000, 15.230000) rotate(90.000000) translate(-17.500000, -15.230000) "
                      points="18 -1.27 18 31.73 17 31.73 17 -1.27"
                    ></polygon>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </i>
      </span>
      <span class="m-split-layout-control-content-icon" (click)="onHorizontal()">
        <i nz-icon *ngIf="horizontalIcon === 'active'">
          <svg
            width="34px"
            height="26px"
            viewBox="0 0 34 26"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="设计" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="04-03平铺模式/视图配置" transform="translate(-1312.000000, -308.000000)">
                <g id="分屏视图" transform="translate(1251.000000, 275.000000)">
                  <g id="编组-4" transform="translate(61.000000, 33.000000)">
                    <g id="编组-3">
                      <rect id="矩形" stroke="#107CEE" fill="#FFFFFF" x="0.5" y="0.5" width="33" height="25" rx="1"></rect>
                      <rect
                        id="矩形"
                        stroke="#107CEE"
                        fill-opacity="0.2"
                        fill="#107CEE"
                        x="0.5"
                        y="0.5"
                        width="33"
                        height="5"
                        rx="1"
                      ></rect>
                      <path
                        d="M3.75,2.5 C4.16421356,2.5 4.5,2.83578644 4.5,3.25 C4.5,3.66421356 4.16421356,4 3.75,4 C3.33578644,4 3,3.66421356 3,3.25 C3,2.83578644 3.33578644,2.5 3.75,2.5 Z M6,2.5 C6.41421356,2.5 6.75,2.83578644 6.75,3.25 C6.75,3.66421356 6.41421356,4 6,4 C5.58578644,4 5.25,3.66421356 5.25,3.25 C5.25,2.83578644 5.58578644,2.5 6,2.5 Z M8.25,2.5 C8.66421356,2.5 9,2.83578644 9,3.25 C9,3.66421356 8.66421356,4 8.25,4 C7.83578644,4 7.5,3.66421356 7.5,3.25 C7.5,2.83578644 7.83578644,2.5 8.25,2.5 Z"
                        id="形状结合"
                        fill="#FFFFFF"
                      ></path>
                      <path
                        d="M6.056,19 L6.968,16.6 L10.904,16.6 L11.816,19 L12.884,19 L9.512,10.432 L8.372,10.432 L5,19 L6.056,19 Z M10.592,15.772 L7.28,15.772 L8.924,11.488 L8.972,11.488 L10.592,15.772 Z"
                        id="A"
                        fill="#107CEE"
                        fill-rule="nonzero"
                      ></path>
                      <path
                        d="M25.668,19 C26.544,19 27.24,18.82 27.744,18.484 C28.332,18.076 28.632,17.452 28.632,16.612 C28.632,16.036 28.464,15.58 28.152,15.22 C27.84,14.86 27.408,14.62 26.844,14.524 C27.276,14.38 27.624,14.152 27.888,13.84 C28.14,13.492 28.272,13.072 28.272,12.592 C28.272,11.92 28.044,11.392 27.588,11.008 C27.12,10.624 26.484,10.432 25.692,10.432 L21.864,10.432 L21.864,19 L25.668,19 Z M25.452,14.176 L22.848,14.176 L22.848,11.26 L25.464,11.26 C26.064,11.26 26.52,11.368 26.832,11.608 C27.144,11.848 27.3,12.208 27.3,12.688 C27.3,13.18 27.132,13.552 26.82,13.804 C26.508,14.044 26.052,14.176 25.452,14.176 Z M25.584,18.172 L22.848,18.172 L22.848,14.992 L25.584,14.992 C26.244,14.992 26.748,15.112 27.096,15.376 C27.456,15.64 27.648,16.048 27.648,16.6 C27.648,17.152 27.432,17.572 27.012,17.836 C26.652,18.052 26.184,18.172 25.584,18.172 Z"
                        id="B"
                        fill="#107CEE"
                        fill-rule="nonzero"
                      ></path>
                    </g>
                    <polygon id="路径-4" fill="#107CEE" fill-rule="nonzero" points="18 6 18 26 17 26 17 6"></polygon>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </i>
        <i nz-icon *ngIf="horizontalIcon === 'non-active'">
          <svg
            width="34px"
            height="26px"
            viewBox="0 0 34 26"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="设计" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="04-03平铺模式/视图配置" transform="translate(-1312.000000, -103.000000)">
                <g id="分屏视图" transform="translate(1251.000000, 70.000000)">
                  <g id="编组-4" transform="translate(61.000000, 33.000000)">
                    <g id="编组-3">
                      <rect id="矩形" stroke="#848484" fill="#FFFFFF" x="0.5" y="0.5" width="33" height="25" rx="1"></rect>
                      <rect
                        id="矩形"
                        stroke="#888889"
                        fill-opacity="0.6"
                        fill="#888889"
                        x="0.5"
                        y="0.5"
                        width="33"
                        height="5"
                        rx="1"
                      ></rect>
                      <path
                        d="M3.75,2.5 C4.16421356,2.5 4.5,2.83578644 4.5,3.25 C4.5,3.66421356 4.16421356,4 3.75,4 C3.33578644,4 3,3.66421356 3,3.25 C3,2.83578644 3.33578644,2.5 3.75,2.5 Z M6,2.5 C6.41421356,2.5 6.75,2.83578644 6.75,3.25 C6.75,3.66421356 6.41421356,4 6,4 C5.58578644,4 5.25,3.66421356 5.25,3.25 C5.25,2.83578644 5.58578644,2.5 6,2.5 Z M8.25,2.5 C8.66421356,2.5 9,2.83578644 9,3.25 C9,3.66421356 8.66421356,4 8.25,4 C7.83578644,4 7.5,3.66421356 7.5,3.25 C7.5,2.83578644 7.83578644,2.5 8.25,2.5 Z"
                        id="形状结合"
                        fill="#FFFFFF"
                      ></path>
                      <path
                        d="M6.056,19 L6.968,16.6 L10.904,16.6 L11.816,19 L12.884,19 L9.512,10.432 L8.372,10.432 L5,19 L6.056,19 Z M10.592,15.772 L7.28,15.772 L8.924,11.488 L8.972,11.488 L10.592,15.772 Z"
                        id="A"
                        fill="#585858"
                        fill-rule="nonzero"
                      ></path>
                      <path
                        d="M25.668,19 C26.544,19 27.24,18.82 27.744,18.484 C28.332,18.076 28.632,17.452 28.632,16.612 C28.632,16.036 28.464,15.58 28.152,15.22 C27.84,14.86 27.408,14.62 26.844,14.524 C27.276,14.38 27.624,14.152 27.888,13.84 C28.14,13.492 28.272,13.072 28.272,12.592 C28.272,11.92 28.044,11.392 27.588,11.008 C27.12,10.624 26.484,10.432 25.692,10.432 L21.864,10.432 L21.864,19 L25.668,19 Z M25.452,14.176 L22.848,14.176 L22.848,11.26 L25.464,11.26 C26.064,11.26 26.52,11.368 26.832,11.608 C27.144,11.848 27.3,12.208 27.3,12.688 C27.3,13.18 27.132,13.552 26.82,13.804 C26.508,14.044 26.052,14.176 25.452,14.176 Z M25.584,18.172 L22.848,18.172 L22.848,14.992 L25.584,14.992 C26.244,14.992 26.748,15.112 27.096,15.376 C27.456,15.64 27.648,16.048 27.648,16.6 C27.648,17.152 27.432,17.572 27.012,17.836 C26.652,18.052 26.184,18.172 25.584,18.172 Z"
                        id="B"
                        fill="#585858"
                        fill-rule="nonzero"
                      ></path>
                    </g>
                    <polygon id="路径-4" fill="#979797" fill-rule="nonzero" points="18 6 18 26 17 26 17 6"></polygon>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </i>
      </span>
    </ng-template>
  `
})
export class MSplitLayoutControlComponent {
  @Input() mText = '';

  direction: IMSplitDirection = 'horizontal';

  get horizontalIcon(): 'active' | 'non-active' {
    return this.direction === 'horizontal' ? 'active' : 'non-active';
  }

  get verticalIcon(): 'active' | 'non-active' {
    return this.direction === 'vertical' ? 'active' : 'non-active';
  }

  constructor(private cdr: ChangeDetectorRef, public splitLayoutService: MSplitLayoutService) {
    this.splitLayoutService.direction$.pipe().subscribe(e => {
      this.direction = e;
      this.cdr.detectChanges();
    });
  }

  onHorizontal(): void {
    this.splitLayoutService.direction$.next('horizontal');
  }

  onVertical(): void {
    this.splitLayoutService.direction$.next('vertical');
  }

  onOnlyLeft(): void {
    this.splitLayoutService.leftArea$.next(100);
    this.splitLayoutService.rightArea$.next(0);
  }
}
